import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import React, { useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import { gregorianToJalali, toFarsiDigits } from '../../assets/utils'
import { useReportFilter, ReportToolbar } from '../../assets/reportFilters'
import { exportExcel, reportMetaNotes, fetchReportQr } from '../../assets/excelUtils'
import { restrictionsState } from '../../pages/contractor/atoms'

/** خروجی اکسل محدودیتها */
const exportRestrictionsExcel = async (contract, restrictions) => {
    const qr = contract && contract.id ? await fetchReportQr(contract.id) : null
    exportExcel({
        filename: 'restrictions.xlsx',
        title: `محدودیت‌ها — ${contract && contract.contractee ? contract.contractee : ''}${contract && contract.number ? ' | قرارداد ' + contract.number : ''}`,
        headers: ['ردیف', 'طرف قرارداد', 'شرح', 'تاریخ ایجاد محدودیت', 'علت ایجاد محدودیت', 'تاریخ خاتمه محدودیت', 'توضیح خاتمه محدودیت'],
        rows: restrictions.map((row, index) => [
            index + 1,
            row.contractee,
            row.remark,
            gregorianToJalali(row.start_date),
            row.reason,
            gregorianToJalali(row.expire_date),
            row.lift_restriction_reason,
        ]),
        notes: reportMetaNotes(),
        qrDataUri: qr,
    })
}

const Restrictions = props => {
    const restrictions = useRecoilValue(restrictionsState)
    const contract = props.contract

    const extract = useMemo(() => ({
        search: (r) => [r.contractee, r.remark, r.reason, r.lift_restriction_reason, r.start_date, r.expire_date],
    }), [])
    const { search, setSearch, year, setYear, years, filtered } = useReportFilter(restrictions, extract)

    return (
        <Box>
            <ReportToolbar search={search} setSearch={setSearch} year={year} setYear={setYear} years={years} />
            {restrictions.length > 0 && (
                <Box style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 8 }}>
                    <Button variant='contained' color='secondary' onClick={() => exportRestrictionsExcel(contract, restrictions)}>
                        دانلود اکسل
                    </Button>
                </Box>
            )}
            <TableContainer elevation={5} component={Paper} style={{ maxHeight: '450px' }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell align='center'><strong>ردیف</strong></TableCell>
                            <TableCell align='center'><strong>طرف قرارداد</strong></TableCell>
                            <TableCell align='center'><strong>شرح</strong></TableCell>
                            <TableCell align='center'><strong>تاریخ ایجاد محدودیت</strong></TableCell>
                            <TableCell align='center'><strong>علت ایجاد محدودیت</strong></TableCell>
                            <TableCell align='center'><strong>تاریخ خاتمه محدودیت</strong></TableCell>
                            <TableCell align='center'><strong>توضیح خاتمه محدودیت</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filtered.map((row, index) => (
                            <TableRow key={row.id}>
                                <TableCell align='center'><strong>{toFarsiDigits(index + 1)}</strong></TableCell>
                                <TableCell align='center'>{toFarsiDigits(row.contractee)}</TableCell>
                                <TableCell align='center'>{toFarsiDigits(row.remark)}</TableCell>
                                <TableCell align='center'>{gregorianToJalali(row.start_date)}</TableCell>
                                <TableCell align='center'>{toFarsiDigits(row.reason)}</TableCell>
                                <TableCell align='center'>{gregorianToJalali(row.expire_date)}</TableCell>
                                <TableCell align='center'>{toFarsiDigits(row.lift_restriction_reason)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}
export default Restrictions
